<template>
  <div class="c-conetntsFile">
    <div class="c-conetntsFile_itemArea">
      <div
        class="c-conetntsFile_itemBox"
        v-for="(file, index) in files"
        :key="index"
      >
        <div class="c-conetntsFile_item">
          <coconala-icon
            name="clip"
            size="20px"
          />
          <span>{{ file.fileName }}</span>
          <a
            href="javascript:;"
            @click="deleteFile(index)"
          >
            <coconala-icon
              name="times-circle"
              :size="closeIconSize"
            />
          </a>
        </div>
      </div>
      <div class="c-conetntsFile_itemBox c-conetntsFile_itemBox-empty"></div>
      <div class="c-conetntsFile_itemBox c-conetntsFile_itemBox-empty"></div><!-- flexの位置調整用 -->
    </div>
    <div
      class="c-conetntsFile_dropzone"
      :class="{ 'c-conetntsFile_dropzone-isHovering': isHovering }"
      slot="dropzone"
      @click="openFinder"
      @dragenter.prevent="isHovering = true"
      @dragover.prevent
      @dragleave.prevent="isHovering = false"
      @drop.prevent.stop="onChange"
    >
      <p>
        <coconala-icon
          name="file-upload"
          size="24px"
        />
      </p>
      <p class="c-conetntsFile_description">
        <span v-if="isPC"><strong>クリック</strong>またはドラッグ&amp;ドロップで</span>ファイルをアップロード
      </p>
      <p class="c-conetntsFile_notice">
        ファイル上限は{{ requestItem.optionJson.max }}つまで、サイズは100MB以内
      </p>
    </div>
    <p
      class="c-conetntsFile_detail"
      v-if="isPC"
    >
      ファイル添付の詳細は<a
        :href="$coconala.helpURL('/articles/360037005534')"
        target="_blank"
      >こちら</a>
    </p>
    <input
      class="c-conetntsFile_input"
      type="file"
      ref="fileInput"
      multiple
      @change="onChange"
    />

    <b-loading
      :active="isUploading"
      :is-full-page="false"
    />
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'

const FILE_UPLOAD_TYPE = 'requests'
const FILE_UPLOAD_SUB_DIRECTORY_UPLOADED = 'uploaded'
const FILE_UPLOAD_SUB_DIRECTORY_MODIFIED = 'modified'
const FILE_UPLOAD_MAX_SIZE = 100000000

export default {
  name: 'ConetntsFile',
  props: {
    requestItem: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      files: [],
      isHovering: false,
      isUploading: false
    }
  },
  computed: {
    ...mapGetters('ui', ['isPC']),
    closeIconSize() {
      return this.isPC ? '16px' : '20px'
    },
    isValid() {
      if (this.requestItem.requiredFlag && this.files.length === 0) {
        return false
      }

      return true
    }
  },
  watch: {
    files() {
      this.$emit('change', {
        name: this.requestItem.name,
        value: this.files,
        isValid: this.isValid
      })
    }
  },
  methods: {
    ...mapActions('file_upload', ['getUploadInfo']),
    openFinder() {
      this.$refs.fileInput.click()
    },
    onChange(event) {
      const fileList = event.target.files
        ? event.target.files // ファイル選択の場合
        : event.dataTransfer.files // ドラッグ&ドロップの場合
      if (this.files.length + fileList.length > this.requestItem.optionJson.max) {
        this.$notify({
          group: 'flash',
          title: 'ファイル数が上限を超えています',
          type: 'error'
        })
        return
      }
      Array.from(fileList).forEach(file => {
        if (file.size > FILE_UPLOAD_MAX_SIZE) {
          this.$notify({
            group: 'flash',
            title: 'ファイルサイズが上限を超えています',
            type: 'error'
          })
          return
        }
        this.uploadFile(file)
      })
    },
    deleteFile(index) {
      this.files.splice(index, 1)
      this.$refs.fileInput.value = ''
    },
    async uploadFile(file) {
      try {
        this.isUploading = true

        // 署名つきURLを取得
        const uuid = this.$util.generateUuid()
        const response = await this.getUploadInfo({
          uploadType: FILE_UPLOAD_TYPE,
          fileName: `${FILE_UPLOAD_SUB_DIRECTORY_UPLOADED}/${uuid}/${file.name}`
        })

        // S3アップロード
        await this.$axios({
          method: 'PUT',
          url: response.uploadInfo.uploadUrl,
          headers: { 'Content-Type': file.type },
          data: file
        })

        const encodedFileName = encodeURIComponent(file.name)
        const fileUrl = this.$coconala.fileURL(
          `/${FILE_UPLOAD_TYPE}/${FILE_UPLOAD_SUB_DIRECTORY_MODIFIED}/${uuid}/${encodedFileName}`
        )
        this.files.push({
          fileName: file.name,
          fileUrl,
          mime: file.type,
          size: file.size
        })

        this.isUploading = false
      } catch (err) {
        this.isUploading = false
        this.$notify({
          group: 'flash',
          title: 'ファイルのアップロードに失敗しました',
          type: 'error'
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.c-conetntsFile {
  position: relative;

  a {
    @include link-effect;
  }

  p {
    margin-bottom: 0;
    line-height: 1;
  }

  &_input {
    display: none;
  }

  &_itemArea {
    display: flex;

    flex-wrap: wrap;
    justify-content: space-between;
  }

  &_itemBox {
    flex: 0 0;
    margin-bottom: 8px;

    &-empty {
      margin: 0;
    }
  }

  &_item {
    display: flex;
    padding: 12px 8px 12px 12px;
    height: 40px;
    border: 1px solid $color-gray-300;
    border-radius: 6px;
    background-color: $color-white;
    font-size: 12px;

    align-items: center;

    span {
      flex: 1;
      overflow: hidden;
      margin: 0 8px;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    a {
      margin-top: 1px;
    }

    .coconala-icon {
      margin-top: 1px;
      color: $color-gray-700;
    }
  }

  &_dropzone {
    @include link-effect;

    margin-top: 8px;
    padding: 24px;
    border: 1px dashed $color-gray-300;
    border-radius: 6px;
    background-color: $color-white;
    text-align: center;
    cursor: pointer;
    transition: opactiy 0.2s;

    &-isHovering {
      border-color: $color-blue-500;
      opacity: 0.7;
    }

    &:hover {
      border-color: $color-blue-500;
    }

    .coconala-icon {
      margin-bottom: 2px;
      color: $color-blue-500;
    }
  }

  &_description {
    margin-top: 8px;
    font-size: 14px;

    strong {
      color: $color-blue-500;
      font-weight: normal;
    }
  }

  &_notice {
    margin-top: 8px;
    font-size: 11px;
  }

  &_detail {
    margin-top: 12px;
    text-align: right;
    font-size: 11px;
  }
}

@media (max-width: breakpoint(Requests, M)) {
  .c-conetntsFile {
    &_itemBox {
      max-width: 100%;

      flex-basis: 100%;
    }

    &_dropzone {
      background-color: $color-bg-pale;
    }

    &_description {
      margin-top: 8px;
      font-size: 12px;
    }

    &_notice {
      margin-top: 8px;
      font-size: 10px;
    }
  }
}

@media (min-width: breakpoint(Requests, M) + 1) {
  .c-conetntsFile {
    &_itemBox {
      max-width: calc((100% - 8px * 2) / 3);

      flex-basis: calc((100% - 8px * 2) / 3);
    }
  }
}
</style>
